import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=ab070cd4&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab070cd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab070cd4')) {
      api.createRecord('ab070cd4', component.options)
    } else {
      api.reload('ab070cd4', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=ab070cd4&scoped=true&", function () {
      api.rerender('ab070cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ogyq2c6sYiCu/JS/comp/Voucher-Unit.vue"
export default component.exports